'use client'
import { memo } from 'react'
import ErrorBoundary from '@error-boundary'
import dynamic from 'next/dynamic'

import type { AcfFormProps } from '@typings'
import { RaContainer, RaPaper } from '@components/core/index.core'

const RaFormWrapper = dynamic(() =>
  import('@components/form-elements/RaFormWrapper/RaFormWrapper').then(
    ({ RaFormWrapper }) => RaFormWrapper
  )
)

export const AcfForm = memo((props: AcfFormProps) => {
  return (
    <RaContainer>
      <RaPaper
        padding={4}
        paddingMobile={4}>
        <ErrorBoundary>
          <RaFormWrapper
            id={props.id}
            expires={props.expires}
            history={props.history}
            redirect={props.redirect}
          />
        </ErrorBoundary>
      </RaPaper>
    </RaContainer>
  )
})
